export interface ParsedQuery {
    text: string;
    filter: string | null;
}

export function parseQuery(q: string): ParsedQuery {
    const trimmed = q.trim();

    // Check if query starts with "is:" delimiter
    const isMatch = trimmed.match(/^is:(\w+)\s*(.*)$/);

    if (isMatch) {
        return {
            filter: isMatch[1] || null,
            text: (isMatch[2] || "").trim()
        };
    }

    return {
        filter: null,
        text: trimmed
    };
}

export function buildQuery(text: string, filter: string | null): string {
    if (!filter) {
        return text.trim();
    }

    if (!text || text.trim() === "") {
        return `is:${filter} `;
    }

    return `is:${filter} ${text.trim()}`;
}
